import { GlobalState } from '@store';

import { TBannersList } from '@interfaces/advertising';

export const getBannersFromStateSelector = (state: GlobalState): TBannersList => state.advertising.banners;
export const getIsLoadedBannersFromStateSelector = (state: GlobalState): boolean => state.advertising.loaded;
